<ng-container *ngIf="routerLink || url; then link; else simple"></ng-container>

<ng-template #link>
  <a [ngClass]="customCls" [routerLink]="routerLink" [href]="url">
    <ng-container [ngTemplateOutlet]="iconTpl"></ng-container>
  </a>
</ng-template>

<ng-template #simple>
  <div [ngClass]="customCls">
    <ng-container [ngTemplateOutlet]="iconTpl"></ng-container>
  </div>
</ng-template>

<ng-template #iconTpl>
  <svg-icon *ngIf="iconType == 'svg'" [src]="icon" [title]="alt" [svgStyle]="svgStyle"> </svg-icon>

  <img
    *ngIf="iconType != 'svg'"
    [src]="icon"
    [alt]="alt"
    [title]="alt"
    [style]="imgStyle"
    [width]="width"
    [height]="height"
  />

  <span *ngIf="badgeCnt > 0" class="badge">
    {{ cnt }}
  </span>
</ng-template>
